import parent from '@/store/interfaces/historicalGeneric'
const mystore = parent({ tipoEvento: 'flujoaprobacion', namespaced: true })

export default mystore
